import { render } from "./AlGoals.vue?vue&type=template&id=7373f645&scoped=true"
import script from "./AlGoals.vue?vue&type=script&lang=js"
export * from "./AlGoals.vue?vue&type=script&lang=js"

import "./AlGoals.vue?vue&type=style&index=0&id=7373f645&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7373f645"]])

export default __exports__